import { useAppDispatch, useAppSelector } from '@/hooks/redux'
import { clearSelectedOrderUuid } from '@/redux/reducers/orders'
import { ordersSelectors } from '@/redux/reducers/orders/selectors'
import { useEffect } from 'react'

export const useClearNonexistentSelectedOrder = (uuid: string): boolean => {
    const isNonexistent = useAppSelector(ordersSelectors.isOrderNonexistent(uuid))
    const selectedOrderUuid = useAppSelector(ordersSelectors.selectedOrderUuid)

    const dispatch = useAppDispatch()

    const isSelected = uuid === selectedOrderUuid

    useEffect(() => {
        if (!isNonexistent || !isSelected) return

        dispatch(clearSelectedOrderUuid())
    }, [isNonexistent, isSelected, dispatch])

    return isNonexistent
}
